import React from "react"

import { AppCategoriesAutocomplete } from "@components/Autocomplete"
import { BACKEND_APIS } from "@constants"
import { categories, disableButton, errors } from "@signals"


export default function AppCommonFiltersCategoriesAutocomplete({ ...props }) {
	return <AppCategoriesAutocomplete
		value={categories.value}
		error={errors.value?.categoryID}
		onChange={e => categories.value = e.target.value}
		onFinishAjax={() => disableButton.value = false}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/execution/options/categories`}
		{...props}
	/>
}